import type { RouteRecordRaw } from 'vue-router'

import { registerAudienceMessages } from './i18n'

import { registerReportMessages } from '@/features/reports'
import { DEFAULT_LOCALE, SUPPORTED_LOCALES, i18n, type SupportedLocale } from '@/shared/i18n'

function activeLocale(): SupportedLocale {
  const locale = i18n.global.locale.value
  return (SUPPORTED_LOCALES as readonly string[]).includes(locale)
    ? (locale as SupportedLocale)
    : DEFAULT_LOCALE
}

export const audienceRoutes: RouteRecordRaw[] = [
  {
    path: 'audience/funnel-exploration',
    name: 'FunnelExploration',
    component: () => import('./components/pages/FunnelExplorationPage.vue'),
    meta: {
      titleKey: 'audience.funnelExploration.title',
      navKey: 'funnelExploration',
      permission: 'integration:ga4',
    },
    beforeEnter: async () => {
      const locale = activeLocale()
      const [{ registerAudienceLayouts }] = await Promise.all([
        import('./flows/registerAudienceLayouts'),
        registerReportMessages(locale),
        registerAudienceMessages(locale),
      ])
      registerAudienceLayouts()
    },
  },
  {
    // ORP-18911 + ORP-18912 supply the complete ten-panel native page. ORP-20041 promotes the
    // legacy path and name; the preview survives as an additive rollback/readiness alias.
    path: 'audience/user-behavior',
    alias: '__preview/audience/user-behavior',
    name: 'UserBehavior',
    component: () => import('./components/pages/UserBehaviorPage.vue'),
    meta: { titleKey: 'audience.userBehavior.title', navKey: 'userBehavior' },
    beforeEnter: async () => {
      const locale = activeLocale()
      const [{ registerAudienceLayouts }] = await Promise.all([
        import('./flows/registerAudienceLayouts'),
        registerReportMessages(locale),
        registerAudienceMessages(locale),
      ])
      registerAudienceLayouts()
    },
  },
  {
    path: 'audience/rfm-clustering',
    name: 'RFMClustering',
    component: () => import('./components/pages/RfmClusteringPage.vue'),
    meta: { titleKey: 'audience.rfm.title', navKey: 'rfmClustering' },
    beforeEnter: async () => {
      const locale = activeLocale()
      const [{ registerAudienceLayouts }] = await Promise.all([
        import('./flows/registerAudienceLayouts'),
        registerReportMessages(locale),
        registerAudienceMessages(locale),
      ])
      registerAudienceLayouts()
    },
  },
]
